<template>
  <v-system-bar
      color="background"
      height="20rem"
  >
    <!-- Filter Colas -->
    <v-menu
        v-if="viewFilterQueues && ((colasList.length>1 && isRolDisplayUser()) || !isRolDisplayUser())"
        max-height="250"
        v-model="menuFilterCola"
        bottom
        offset-y
        :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            small
            v-bind:class = "(!isRolDisplayUser())?'neu-glow mr-3':'neu-glow mr-3 mt-8'"
            width="`${colaSelectLength}`em"
            v-bind="attrs"
            v-on="on"
        >
          <v-icon color="primary" class="mr-2" left>
            mdi-format-list-bulleted
          </v-icon>
          <span v-show="!isMobile">{{ $t('Global.DashboardBase.cola') }}
            <span class="ml-2"> {{ textCola }} </span>
          </span>
        </v-btn>
      </template>
      <v-list color="background">
        <v-list-item-group
            color="background"
            class="v-text-search-custom">
          <v-list-item>
            <v-text-field
                color="background"
                dense
                class="neu-input"
                v-model="searchCola"
                :label="searchLabelText"
                hide-details/>
          </v-list-item>
        </v-list-item-group>
        <v-list-item-group color="background" v-model="modelCola">
          <v-list-item
              max-height="240"
              style="overflow-y: auto;"
              color="primary"
              v-for="(item, index) in colasList"
              :key="index.nodeName"

          >
            <v-list-item-content @click="changeColaData(item)">
              <v-list-item-title>{{ item.nodeName }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <!-- Filter Agentes -->
    <v-menu
        v-if="viewFilterAgents && !isRolDisplayUser()"
        max-height="250"
        v-model="menuFilterAgente"
        bottom
        offset-y
        :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            small
            class="neu-glow mr-3"
            width="`${colaSelectLength}`em"
            v-bind="attrs"
            v-on="on"
        >
          <v-icon color="primary" class="mr-2" left>
            mdi-face-agent
          </v-icon>
          <span v-show="!isMobile">{{ $t('Global.DashboardBase.agent') }} <span class="ml-2"> {{
              textAgent
            }}</span></span>
        </v-btn>
      </template>
      <v-list color="background">
        <v-list-item-group
            color="background"
            class="v-text-search-custom">
          <v-list-item>
            <v-text-field
                background-color="background"
                color="background"
                dense
                class="neu-input"
                v-model="searchAgent"
                :label="searchLabelText"
                hide-details/>
          </v-list-item>
        </v-list-item-group>
        <v-list-item-group color="background" v-model="modelAgent">
          <v-list-item
              max-height="240"
              style="overflow-y: auto;"
              color="primary"
              v-for="(item, index) in agentsList"
              :key="index.nodeName"
          >
            <v-list-item-content @click="changeAgentData(item)">
              <v-list-item-title>{{ item.nodeName }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>

    <v-spacer/>
    <!-- Filter Dates -->
    <v-sheet v-show="viewFilterDate" v-if="!isRolDisplayUser()">
      <v-menu
          v-model="menuFilters"
          offset-y
          :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn
              small
              v-on="on"
              class="neu-glow mr-3"
              color="background">
            <v-icon
                color="primary" class="mr-2" left>
              mdi-update
            </v-icon>
            <span v-show="!isMobile">{{ textDate }}</span>
          </v-btn>
        </template>
        <v-card color="background" class="card-dates px-4" min-width="500">
          <vuse-section-definition
              :title="!isMobile ? $t('Global.DashboardBase.time-ranges') : '' "
              icon="mdi-calendar-search"/>
          <v-sheet color="background" :class="dateRangeCSS">
            <v-sheet color="background">
              <v-menu
                  ref="menu"
                  v-model="menuDatePicker"
                  :close-on-content-click="isAllDatesPikerSelected"
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on }">
                  <v-card color="background" flat>
                    <v-card-subtitle v-if="isMobile">
                      {{ $t("Global.DashboardBase.time-ranges-absolute") }}
                      <v-btn
                          fixed
                          right
                          small
                          plain
                          color="background"
                          @click="timeRangesExpandable = !timeRangesExpandable"
                      >
                        <v-icon color="primary" class="mr-2" left>
                          {{
                            timeRangesExpandable ? 'mdi-arrow-up-drop-circle-outline' :
                                'mdi-arrow-down-drop-circle-outline'
                          }}
                        </v-icon>
                        <span v-show="!isMobile">{{ textRefresh }} </span>
                      </v-btn>
                    </v-card-subtitle>
                    <v-card-text
                        transition="scale-transition"
                        v-show="showTimeRangesExpandable">
                      <v-text-field
                          :class="isMobile ? 'neu-input v-text-field-custom' : 'neu-input'"
                          v-model="datesPiker[0]"
                          :label="fromLabelText">
                        <template v-slot:append>
                          <v-btn
                              small
                              plain
                              v-on="on"
                              @click="menuDatePicker = true">
                            <v-icon>
                              mdi-calendar
                            </v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                      <v-text-field
                          :class="isMobile ? 'v-text-field-custom' : ''"
                          class="neu-input"
                          v-model="datesPiker[1]"
                          :label="toLabelText">
                        <template v-slot:append>
                          <v-btn
                              small
                              plain
                              v-on="on"
                              @click="menuDatePicker = true">
                            <v-icon>
                              mdi-calendar
                            </v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-card-text>
                  </v-card>
                </template>
                <v-date-picker
                    :locale="localeGeneral"
                    color="primary"
                    ref="picker"
                    no-title
                    range
                    @input="inputDatePicker"
                    :max="new Date().toISOString().substr(0, 10)"
                    v-model="datesPiker"/>
              </v-menu>
              <v-btn
                  v-show="showTimeRangesExpandable"
                  small
                  class="ml-3 mr-3 mb-3"
                  color="primary"
                  @click="rangeCustom"
                  :disabled="isDifferentDatesSelected"
              >
                {{ $t("Global.DashboardBase.apply-time") }}
              </v-btn>
            </v-sheet>

            <v-divider v-show="isMobile"/>

            <v-sheet color="background">
              <v-card color="background" min-height="300" flat>
                <v-card-subtitle v-if="isMobile">
                  {{ $t("Global.DashboardBase.speed-ranges") }}
                </v-card-subtitle>
                <v-card-subtitle>
                  <v-text-field
                      :class="isMobile ? 'neu-input v-text-field-custom' : 'neu-input'"
                      v-model="searchRange"
                      :label="searchSpeedRangesLabelText()"
                      single-line
                      hide-details/>
                </v-card-subtitle>
                <v-card-text>
                  <v-list dense
                          max-height="200"
                          style="overflow-y: auto;"
                          color="background"
                          outlined>
                    <v-list-item-group color="background" v-model="modelFixedDate">
                      <v-list-item v-for="(item) in dateList"
                                   :key="item.key"
                                   :input-value="dateSelected.key"
                                   color="primary">
                        <v-list-item-content @click="rangeFixed(item)">
                          <v-list-item-title v-text="item.text"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-sheet>
          </v-sheet>
        </v-card>
        <v-btn
            icon
            absolute
            top
            right
            @click="menuFilters = false"
        >
          <v-icon small>close</v-icon>
        </v-btn>
      </v-menu>
    </v-sheet>

    <!-- Refresh Dashboard -->
    <v-menu
        bottom
        offset-y
        :close-on-content-click="false" v-if="!isRolDisplayUser()">
      <template v-slot:activator="{ on: onMenu, attrs: onAttrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }">
            <v-btn
                small
                class="neu-glow mr-3"
                color="background"
                v-bind="{...onAttrs, ...attrsTooltip}"
                v-on="{...onMenu, ...onTooltip}"
                @click="$emit('refresh-iframe')"
            >
              <v-icon color="primary" class="mr-2" left>
                mdi-cached
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Global.DashboardBase.refresh-dashboard') }}</span>
        </v-tooltip>
      </template>

    </v-menu>
    <!-- Filter Refresh -->
    <v-menu
        max-height="200"
        v-model="menuFilterRefresh"
        bottom
        offset-y
        :close-on-content-click="false" v-if="!isRolDisplayUser()">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            small
            class="neu-glow mr-3"
            color="background"
            v-bind="attrs"
            v-on="on"
        >
          <v-icon color="primary" class="mr-2" left>
            {{ menuFilterRefresh ? 'mdi-arrow-up-drop-circle-outline' : 'mdi-arrow-down-drop-circle-outline' }}
          </v-icon>
          <span v-show="!isMobile">{{ textRefresh }}</span>
        </v-btn>
      </template>
      <v-list color="background">
        <v-list-item-group color="background" v-model="modelRefresh">
          <v-list-item
              max-height="200"
              style="overflow-y: auto;"
              v-for="item in refresh"
              :key="item"
              color="primary"
          >
            <v-list-item-content @click="changeRefreshData(item)">
              <v-list-item-title>{{ item }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

    </v-menu>
    <!-- reset init data  -->
    <v-menu
        bottom
        offset-y
        :close-on-content-click="false" v-if="!isRolDisplayUser()">
      <template v-slot:activator="{ on: onMenu, attrs: onAttrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }">
            <v-btn
                small
                class="neu-glow mr-3"
                color="background"
                v-bind="{...onAttrs, ...attrsTooltip}"
                v-on="{...onMenu, ...onTooltip}"
                @click="initFilterValues()"
            >
              <v-icon color="primary" class="mr-2" left>
                mdi-backup-restore
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Global.DashboardBase.reset-data-dashboard') }}</span>
        </v-tooltip>
      </template>
    </v-menu>
  </v-system-bar>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import ROL from "@/config/rol-values";

const HOURS_23_MILI = 86340;

export default {
  name: 'dashboard-filters',
  props: {
    agents: {
      type: Array,
      default: ()=> []
    },
    colas: {
      type: Array,
      default: ()=> []
    },
    dates: {
      type: Array,
      default: ()=> []
    },
    refresh: {
      type: Array,
      default: ()=> []
    },
    filtersViews: {
      type: Array,
      default: ()=> []
    },
    dashboardId: {
      type: Number,
      default: ()=> 0
    }
  },
  data() {
    return {
      menuFilterCola: false,
      textCola: '',
      urlColaParams: '',
      searchCola: '',
      menuFilterAgente: false,
      textAgent:'',
      urlAgentParams: '',
      searchAgent:'',
      menuFilters: false,
      menuDatePicker: false,
      dateSelected: {},
      searchRange: '',
      datesPiker: [],
      timeRangesExpandable: true,
      menuFilterRefresh: false,
      urlRefreshParams: '',
      textRefresh: '',
      modelCola: 0,
      modelAgent: 0,
      modelFixedDate: 0,
      modelRefresh: 0,
      showDateFilter: null,
      rol: ROL
    }
  },
  computed: {
    ...mapGetters({localeGeneral: "locale"}),
    ...mapGetters(["getRoleId"]),
    isMobile() {
      return !this.$vuetify.breakpoint.smAndUp
    },
    urlFull() {
      const cola = this.urlColaParams ? `&${this.urlColaParams}` : ''
      const date = this.urlDateParams ? `&${this.urlDateParams}` : ''
      const agent = this.urlAgentParams ? `&${this.urlAgentParams}` : ''
      const refresh = this.urlRefreshParams ? `&${this.urlRefreshParams}` : ''
      return `${cola}${date}${agent}${refresh}`
    },
    colasList() {
      return this.colas?.filter((i) => i.nodeName?.toLocaleLowerCase().includes(this.searchCola))
    },
    agentsList() {
      return this.agents?.filter((i) => i.nodeName?.toLocaleLowerCase().includes(this.searchAgent))
    },
    searchLabelText() {
      return this.$t('Global.DashboardBase.search')
    },
    textDate() {
      return this.dateSelected?.text || this.$t("Global.DashboardBase.last-date")
    },
    dateRangeCSS() {
      return this.isMobile ? '' : 'date-range-container-flex'
    },
    isAllDatesPikerSelected() {
      return this.datesPiker?.length > 1
    },
    showTimeRangesExpandable() {
      return !this.isMobile || this.timeRangesExpandable
    },
    fromLabelText() {
      return this.$t('Global.DashboardBase.from')
    },
    toLabelText() {
      return this.$t('Global.DashboardBase.to')
    },
    isDifferentDatesSelected() {
      return !(this.isAllDatesPikerSelected && this.datesPiker[0] !== this.datesPiker[1])
    },
    dateFrom() {
      const date = new Date(this.datesPiker[0]).getTime() < new Date(this.datesPiker[1]).getTime() ? this.datesPiker[0] : this.datesPiker[1]
      return this.isAllDatesPikerSelected ? moment(date).format('DD/MM/YY HH:mm:ss') : ''
    },
    dateTo() {
      const date = new Date(this.datesPiker[1]).getTime() > new Date(this.datesPiker[0]).getTime() ? this.datesPiker[1] : this.datesPiker[0]
      return this.isAllDatesPikerSelected ? moment(date).format('DD/MM/YY HH:mm:ss') : ''
    },
    dateList() {
      return this.dates.filter((i) => i.text.toLocaleLowerCase().includes(this.searchRange))
    },
    viewFilterQueues(){
      return this.filtersViews.includes('queues')
    },
    viewFilterAgents(){
      return this.filtersViews.includes('agents')
    },
    viewFilterDate(){
      return this.showDateFilter !== 2 && this.showDateFilter !== null
    }
  },
  watch: {
    dashboardId: {
      handler(id)
      {
        this.showDateFilter = id
        this.initFilterValues()
      },
      deep: true
    },
    colas:{
      handler() {
        this.initFilterValues()
      },
      deep: true
    },
  },
  methods: {
    ...mapActions("navigations", ["setSidenavVisibility", "setHeaderVisibility" ]),
    changeColaData(data) {
      this.urlColaParams = data.nodeName ? `&var-Cola=${data.nodeName}` : ''
      this.menuFilterCola = false
      this.textCola = data.nodeName
      const urlTmp = `&${this.urlColaParams}&${this.urlDateParams}&${this.urlAgentParams}&${this.urlRefreshParams}`
      this.$emit('url-params', urlTmp)
    },
    changeAgentData(data) {
      this.urlAgentParams = data.nodeName ? `&var-Agente=${data.nodeName}` : ''
      this.menuFilterAgente = false
      this.textAgent = data.nodeName
      const urlTmp = `&${this.urlColaParams}&${this.urlDateParams}&${this.urlAgentParams}&${this.urlRefreshParams}`
      this.$emit('url-params', urlTmp)
    },
    changeRefreshData(data) {
      const control = !!data && data !== 'Off'
      this.urlRefreshParams = control ? `&refresh=${data}` : ''
      this.menuFilterRefresh = false
      this.textRefresh = control ? data : ''
      const urlTmp = `&${this.urlColaParams}&${this.urlDateParams}&${this.urlAgentParams}&${this.urlRefreshParams}`
      this.$emit('url-params', urlTmp)
    },
    changeDateData(data) {
      this.urlDateParams = data?.from && data?.to ? `&from=${data.from}&to=${data.to}` : ''
      this.menuFilters = false
      this.dateSelected = data
      const urlTmp = `&${this.urlColaParams}&${this.urlDateParams}&${this.urlAgentParams}&${this.urlRefreshParams}`
      this.$emit('url-params', urlTmp)
    },
    inputDatePicker(listDate) {
      const status = listDate.length === 1
      if (status) {
        this.datesPiker[0] = listDate[0].toString() + ' 00:00:00'
      } else {
        this.datesPiker[1] = listDate[1].toString() + ' 23:59:59'
      }
      this.menuDatePicker = status
    },
    rangeCustom() {
      this.menuFilters = false;
      const dateTimeFirst = Math.round(new Date(this.datesPiker[0]).getTime());
      const dateTimeSecond = Math.round(new Date(this.datesPiker[1]).getTime());
      const from = dateTimeFirst < dateTimeSecond ? dateTimeFirst : dateTimeSecond;
      const to = (dateTimeFirst > dateTimeSecond ? dateTimeFirst : dateTimeSecond) + HOURS_23_MILI;

      let data = {...this.dateSelected}
      data['text'] = `${this.dateFrom} a ${this.dateTo}`
      data['from'] = from
      data['to'] = to
      this.changeDateData(data)
    },
    rangeFixed(data) {
      this.datesPiker = []
      this.changeDateData(data)
    },
    searchSpeedRangesLabelText() {
      return this.$t('Global.DashboardBase.search-speed-ranges')
    },
    async initFilterValues() {
      this.urlColaParams = ''
      this.urlDateParams = ''
      this.urlAgentParams = ''
      this.urlRefreshParams = ''

      this.modelRefresh = this.refresh?.findIndex((i)=> i === 'Off')
      this.changeRefreshData('Off')

      if(this.colas.length > 0){
        this.modelCola = 0
        const nodeName = this.colas[0].nodeName
        !this.viewFilterQueues || this.changeColaData({nodeName})
      }

      if(this.agents.length > 0) {
        this.modelAgent = 0
        const nodeNameAgents = this.agents[0].nodeName
        !this.viewFilterAgents || this.changeAgentData({nodeName: nodeNameAgents})
      }

      this.modelFixedDate = this.dates?.findIndex((i)=> i.key === 'today')
      const date = this.dates[this.modelFixedDate]
      this.changeDateData(date)
    },
    isRolDisplayUser(){
      return [this.rol.DISPLAY_USER].includes(this.getRoleId)
    },
    handleSidenavDrawer() {
      this.$store.dispatch("navigations/setSidenavVisibility");
    },
    toggleMiniVariant() {
      this.$store.dispatch("navigations/setMiniVariant");
    }
  }
}
</script>
<style>

.card-dates {
  overflow-y: hidden;
  overflow-x: hidden;
}
.v-text-field-custom {
  width: 65vw;
}

.v-text-search-custom {
  position: sticky;
  top:0;
  opacity: 1;
  z-index:10;
}

.date-range-container-flex {
  display: flex;
  flex-direction: row;
  width: 100%;
}
</style>
